import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

// Fires a GA + in-house pageview every time the route changes.
export default function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => {
    trackPageview(loc.pathname + loc.search);
  }, [loc.pathname, loc.search]);
  return null;
}
